import { render, staticRenderFns } from "./TimePeriodDisplay.vue?vue&type=template&id=9b88f2a6&scoped=true&"
import script from "./TimePeriodDisplay.vue?vue&type=script&lang=js&"
export * from "./TimePeriodDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TimePeriodDisplay.vue?vue&type=style&index=0&id=9b88f2a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b88f2a6",
  null
  
)

export default component.exports